module.exports = __webpack_public_path__ + "html/notifications-wrap.template.html";